<template>
  <v-card>
    <v-card-title>
      <h4>パスワード変更</h4>
    </v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-text-field label="現在のパスワード" required type="password"
                      v-model="currentPassword" :rules="requiredFieldRules"
        />
        <v-text-field label="新しいパスワード" required type="password"
                      v-model="newPassword" :rules="requiredFieldRules"
        />
        <v-text-field label="新しいパスワード（確認）" required type="password"
                      v-model="newPasswordRetype" :rules="passwordRetypeRules"
        />
      </v-form>

      <v-alert warning v-model="visibleErrMessage" v-text="errMessage" />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn flat primary @click="changePassword">変更</v-btn>
      <v-btn flat error @click="cancel">キャンセル</v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import BaseComponent from '@/components/BaseComponent'

// 必須項目ルール
const requiredRule = (v) => !!v || '必須項目です。'

export default {
  name: 'PasswordChange',
  extends: BaseComponent,
  data () {
    return {
      currentPassword: null,
      newPassword: null,
      newPasswordRetype: null,

      requiredFieldRules: [requiredRule],

      errMessage: null,
      visibleErrMessage: false
    }
  },
  computed: {
    passwordRetypeRules () {
      return [
        requiredRule,
        (v) => {
          if (!this.newPassword) return true
          if (v === this.newPassword) return true

          return 'パスワードが一致しません。'
        }
      ]
    }
  },
  methods: {
    // パスワード変更
    changePassword () {
      if (!this.$refs.form.validate()) return

      this.api.updateEndUserPassword({
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      })
      .then(res => {
        this.$router.go(-1)
      })
      .catch(err => {
        if (err.response && err.response.status === 409) {
          this.errMessage = '現在のパスワードが一致しません。'
          this.visibleErrMessage = true
        } else {
          this.handleError('パスワードの変更に失敗しました。', err)
        }
      })
    },

    // キャンセル
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PasswordChange.vue?3ec60b61